import { useState, useEffect } from 'react'
import { profileUrl } from '../../api/tmdb'

/**
 * Cinematic reveal screen — shown on ALL devices simultaneously when
 * party.status === 'reveal'. Actors pop in after a 1.5-second title hold.
 * The host device separately manages the timed advance to 'countdown'.
 */
export default function PartyRevealScreen({ startActor, goalActor }) {
  const [showActors, setShowActors] = useState(false)

  useEffect(() => {
    const id = setTimeout(() => setShowActors(true), 1500)
    return () => clearTimeout(id)
  }, [])

  return (
    <div className="party-reveal-screen">
      <p className="party-reveal-screen__title">The cast has been chosen...</p>

      {showActors && (
        <div className="party-reveal-screen__matchup">
          <RevealActor actor={startActor} label="START" />
          <span className="party-reveal-screen__arrow">→</span>
          <RevealActor actor={goalActor} label="GOAL" />
        </div>
      )}
    </div>
  )
}

function RevealActor({ actor, label }) {
  if (!actor) return null
  return (
    <div className="party-reveal-screen__actor">
      <img
        className="party-reveal-screen__actor-img"
        src={actor.profile_path ? profileUrl(actor.profile_path, 'w185') : ''}
        alt={actor.name}
        onError={(e) => { e.target.style.opacity = '0.3' }}
      />
      <p className="party-reveal-screen__actor-label">{label}</p>
      <p className="party-reveal-screen__actor-name">{actor.name}</p>
    </div>
  )
}
